import Product from '../model/Product'

const CrossSellController = function ($scope, Cart, CrossSell) {

  $scope.CrossSell = CrossSell;

  $scope.showGiftwrapper = function (productCategory) {
    return CrossSell.moreGiftWrapperAllowed && $scope.isGiftWrapper(productCategory);
  };

  $scope.isGiftWrapper = function (productCategory) {
    return productCategory[ 'tags' ].indexOf('giftwrapper') !== -1;
  };

  $scope.showOptionsLayerByCategory = {};

  $scope.setShowOptionsLayer = function (productCategory, value) {
    $scope.showOptionsLayerByCategory[ productCategory.id ] = value;
  };

  CrossSell.showProductCategory = function (idOfProductCategories) {
    $scope.showOptionsLayerByCategory[ idOfProductCategories ] = true;
  };

  $scope.onProductClick = function (product, productCategory) {
    CrossSell.toggleCrossSellProduct(product, productCategory)
      .then(function () {
        var optionLayerIsShown = $scope.showOptionsLayerByCategory[ productCategory.id ];
        var categoryInCart = Cart.haveProductsOfCategory(productCategory);

        var showOptionLayer = true;
        if (!categoryInCart && !optionLayerIsShown) {
          showOptionLayer = false;
        }
        $scope.setShowOptionsLayer(
          productCategory, showOptionLayer
        );
      });
  };

  /**
   *
   * @see imgorientation
   * @param {Product} product
   * @param {string} modalId
   */
  $scope.onProductClickToShowModal = function (product, modalId) {
    /**
     * to set the orientation of the modal-images because the images was
     * loaded before modal is shown
     */
    angular.element('#' + modalId)
      .find('.images img')
      .each(function (index, element) {
        angular.element(element).trigger('load');
      });

    // to reset the amount and set it to wishes
    product.setAmountToWishes();
  };

  $scope.updateCart = function (product, productCategory) {
    product.setWishesToAmount();

    if (product.getTotalWishCount() === 0) {
      for (var index in product.detailData.productsizes) {
        CrossSell.changeCrossSellProductAmount(product.id, productCategory.id, index, 0);
      }
      return CrossSell.removeSingleCrossSellProductFromCart(productCategory, product);
    } else {
      return CrossSell.addCrossSellProductToCart(product, productCategory);
    }
  };

  $scope.showProduct = function (product, productCategory, actualIndexInCategory, maxShow) {

    var optionLayerIsShown = $scope.showOptionsLayerByCategory[ productCategory.id ];
    var isChecked = $scope.isChecked(product, productCategory);
    var categoryInCart = Cart.haveProductsOfCategory(productCategory);


    var show = true;
    if (!isChecked && optionLayerIsShown
      && (actualIndexInCategory > maxShow || categoryInCart)) {
      show = false;
    }

    return show;
  };

  $scope.showProductWithoutCartCheck = function (product, productCategory, actualIndexInCategory, maxShow) {

    var optionLayerIsShown = $scope.showOptionsLayerByCategory[ productCategory.id ];
    var isChecked = $scope.isChecked(product, productCategory);

    var show = true;
    if (!isChecked && optionLayerIsShown
      && (actualIndexInCategory > maxShow)) {
      show = false;
    }

    return show;
  };

  $scope.isChecked = function (product, productCategory) {
    var checked = false;
    var input = document.getElementById('crosssell-' + productCategory.id + '-' + product.id);
    if (input) {
      checked = input.checked;
    }
    return checked;
  };

  // initial status for the OptionsLayerByCategory
  for (var key in CrossSell.productCategories) {
    if (!CrossSell.productCategories.hasOwnProperty(key)) {
      continue;
    }
    var productCategory = CrossSell.productCategories[ key ];
    $scope.showOptionsLayerByCategory[ productCategory.id ] = true;
    if (Cart.haveProductsOfCategory(productCategory)) {
      $scope.setShowOptionsLayer(productCategory, true);
    }
  }

};


export default CrossSellController;